$(document).ready(function(){

	// -- update attributes on click --
	$('[aria-expanded]').each(function() {
  	$(this).on('click', function(){
  		if (!$(this).hasClass('accordion__summary')) {
				$(this).attr('aria-expanded', function (i, attr) {
					// -- update tabindex --
					var newTabindexVal = (attr == 'true') ? '-1' : '0';
					$(this).next().find('[tabindex]').attr('tabindex',newTabindexVal);
					// -- update aria-expanded --
			    return attr == ('true') ? 'false' : 'true';
				});
  		}
		});
	});

	// -- update attributes on focusout (mainMenu) --
	$('.header__mainMenu .level--2:last-child .menu-item').on('focusout', function() {
  	$('.header__mainMenu .level--2 .menu-item').attr('tabindex', '-1');
  	$('.dropdown__list.open').removeClass('open');
  	$('.header__mainMenu .dropdown__toggle').attr('aria-expanded', 'false');
	});

});